import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Player, Team, AuctionBid } from '../../../../sdk/model';
import { Box, Typography } from '@mui/material';
import MinimumBidButton from './MinimumBidButton';
import CustomBidModal from './CustomBidModal';
import { MINIMUM_BID_INCREMENT, MINIMUM_ONE_YEAR_SALARY, MINIMUM_BID_INCREASE_PCT } from '../../../util/ContractUtils';

interface auctionBiddingModalProps {
  selectedPlayer: Player | undefined,
  teamMap: Map<String | undefined, Team>,
  nominationTeamId: String | undefined,
  leadingBid: AuctionBid | undefined,
  currentSeason: number | undefined,
  remainingContractLengths: Map<number, number>,
  maxBid: number | undefined,
  disabled: boolean,
  auctionId: string,
  teamId: string | undefined
}

function AuctionBiddingModal(props: auctionBiddingModalProps) {
  const {leagueId} = useParams();
  const [leadingBid, setLeadingBid] = React.useState(props.leadingBid);
  
  React.useEffect(() => {
    setLeadingBid(props.leadingBid)
  }, [props.leadingBid])
  
  function getOneYearValue(years: number, totalAmount: number) {
    if (years === 1) {
      return totalAmount;
    }
    const factorReduction = ((years - 1) * 2.0 - 1) / 3.0;
    const divisionFactor = years - factorReduction;
    return totalAmount / divisionFactor;
  }
  
  const years = leadingBid?.years ? leadingBid?.years : 0;
  const totalAmount = leadingBid?.totalAmount ? leadingBid?.totalAmount : MINIMUM_ONE_YEAR_SALARY;
  const oneYearValue = getOneYearValue(years, totalAmount);
  const minimumRaise = Math.round(Math.max(oneYearValue * MINIMUM_BID_INCREASE_PCT, MINIMUM_BID_INCREMENT) / MINIMUM_BID_INCREMENT) * MINIMUM_BID_INCREMENT; 
  const minimumOneYearOfferValue = Math.ceil(oneYearValue/MINIMUM_BID_INCREMENT) * MINIMUM_BID_INCREMENT + minimumRaise;
  
  return <Box sx={{ display: 'inline-block', overflowX: 'auto'}}>
    <Box sx={{ float: 'left' }}>
      <Typography variant="h5" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
        Minimum Bids
      </Typography>
      {[...Array(4).keys()].map(i => i + 1).map(bidYears => 
        <MinimumBidButton years={bidYears} minimumOneYearOfferValue={minimumOneYearOfferValue} currentSeason={props.currentSeason} bidsRemaining={props.remainingContractLengths[bidYears]} maxBid={props.maxBid === undefined ? 0 : props.maxBid} disabled={props.disabled} auctionId={props.auctionId} teamId={props.teamId} />
      )}
    </Box>
    <CustomBidModal minimumOneYearOfferValue={minimumOneYearOfferValue} currentSeason={props.currentSeason} maxBid={props.maxBid === undefined ? 0 : props.maxBid} disabled={props.disabled} auctionId={props.auctionId} teamId={props.teamId} remainingContractLengths={props.remainingContractLengths} selectedPlayer={props.selectedPlayer} />
  </Box>
}

export default AuctionBiddingModal;